
export default function ListingCard(prop){
    return (
        <div class="col-lg-4">
            <div class="ltn__product-item ltn__product-item-4 text-center---">
                <div class="product-img">
                    <a href=""><img src={prop.info.media.medium} alt="#"/></a>
                    <div class="product-badge">
                        <ul>
                            <li class="sale-badge bg-green">{prop.info.type == 'rent' ? 'Affitto' : 'Vendita'}</li>
                        </ul>
                    </div>
                    <div class="product-img-location-gallery">
                        <div class="product-img-location">
                            <ul>
                                <li>
                                    <a href=""><i class="flaticon-pin"></i> {prop.info.location.address}, {prop.info.location.city}</a>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                </div>
                <div class="product-info">
                    <div class="product-price">
                        <span>{prop.info.formatted_price}<label>{prop.info.type == 'rent' ? '/mese' : ''}</label></span>
                    </div>
                    <h2 class="product-title"><a href={"/inserzione/" + prop.info.id}>{prop.info.title}</a></h2>
                    <div class="product-description">
                        <p>{prop.info.description.substring(0,200)}</p>
                    </div>
                     <ul class="ltn__list-item-2 ltn__list-item-2-before">
                        <li>
                            <span>3 <i class="flaticon-bed"></i></span>
                            Locali
                         </li>
                        <li>
                            <span>2 <i class="flaticon-clean"></i></span>
                            Bagni
                        </li>
                        <li><span>{prop.info.surface} <i class="flaticon-square-shape-design-interface-tool-symbol"></i></span>
                            superficie
                        </li>
                    </ul>
                </div>
                
            </div>
        </div>
    );
}